import { render, staticRenderFns } from "./perform.vue?vue&type=template&id=04c788e9&"
import script from "./perform.vue?vue&type=script&lang=js&"
export * from "./perform.vue?vue&type=script&lang=js&"
import style0 from "./perform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports